import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];
const draw = (delay, duration = 1.2) => ({
  initial: { pathLength: 0, opacity: 0 },
  whileInView: { pathLength: 1, opacity: 1 },
  viewport: { once: true, amount: 0.3 },
  transition: { pathLength: { duration, ease, delay }, opacity: { duration: 0.2, delay } },
});

export const Sapling = () => (
  <div className="ph-sapling shrink-0" aria-hidden="true" data-testid="sapling-visual">
    <svg viewBox="0 0 120 120" className="w-full h-full" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <motion.path d="M22 92 H98" {...draw(0, 0.8)} strokeOpacity="0.6" />
      <ellipse cx="60" cy="96" rx="7" ry="4.5" fill="currentColor" stroke="none" />
      <motion.path d="M60 92 C60 78 57 66 60 50" {...draw(0.5)} />
      <motion.path d="M59.5 64 C50 64 41 58 38 47 C49 46 57 52 59.5 64 Z" {...draw(1.2, 1)} />
      <motion.path d="M60.5 54 C66 44 75 39 86 40 C84 52 74 58 60.5 54 Z" {...draw(1.5, 1)} />
      <motion.path d="M60 50 C60 42 62 35 65 30" {...draw(1.9, 0.8)} />
    </svg>
  </div>
);
